import api from "./axiosInstance";

export const getCompanyExpenses = async () => {
  const res = await api.get("api/v1/company-expenses/");
  return res.data;
};

export const createCompanyExpenses = async (payload) => {
  const res = await api.post(`api/v1/company-expenses/`, payload);
  return res.data;
};


export const updateCompanyExpenses = async (id, payload) => {
  const res = await api.patch(`api/v1/company-expenses/${id}/`, payload);
  return res.data;
};

export const deleteCompanyExpenses = async (id) => {
  await api.delete(`api/v1/company-expenses/${id}/`);
};